import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateProfileData } from "../services/firebase";
import { updateGuestProfile } from "../services/guestStorage";

// Mutation for updating Profile (Vitals)
export const useUpdateProfile = (uid) => {
  const queryClient = useQueryClient();
  const isGuest = !uid || uid === "guest";

  return useMutation({
    mutationFn: (data) =>
      isGuest ? updateGuestProfile(data) : updateProfileData(uid, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["profile", uid] });
    },
  });
};
